import React from 'react'
import CSS from './LandingPage.module.css';

function Section4() {
    return (
        <div className={`${CSS.section4}`}>
        <div className={CSS.content4}>
        <div className={CSS.avatar} id={CSS.avatar1}></div>
        <h2>Write to Us ...</h2>
          <ul>
            <li > How can we serve you better and who all should we add as our associate seller</li>
            <li > Your reviews are important for us ,so as to  improve our services and thrive our network</li>
            <li>Write to us-<p className="text-primary text-decoration-underline">connect2cocentric@gmail.com</p></li>
          </ul>
        </div>
        <div className={CSS.content4} >
          <div className={CSS.avatar}  id={CSS.avatar2}></div>
          <h2>Our Goal </h2>
          <ul>
            <li >For manufacturing industries - offering variety in service and increasing the accessibility in the market.</li>
            <li >For sellers - offering opportunity for selling products and serve manufacturing industries with our platform , removing the constraint of vendor registration.</li>
          </ul>
        </div>

        <div className={CSS.content4}>
        <div className={CSS.avatar} id={CSS.avatar3} ></div>

        <h2> Why to choose us ?</h2>
          <ul>
            <li >For industries - get the service numbers from us providing you an option to pick the best available service for you at resonable low rates.</li>
            <li >For sellers- enhancing the reach of the products or services to manufacturing industries and creating ease of doing business by joining our platform.</li>
          </ul>
        </div>
        </div>
      )
}

export default Section4
